import axios from 'axios';

import { setSession, getCookie } from '../utils.tsx';
import { STORAGE_KEY } from '../enums.tsx';

export const API_URL = process.env.REACT_APP_DISPATCH_API_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;

// ----------------------------------------------------------------------

export const axiosInstance = axios.create({ baseURL: API_URL });

let accessToken = localStorage.getItem("token");

// let currentValue = getCookie();
  // let currentValue = Utils.getProjectVersion();
// let isV4 = (currentValue == null || currentValue == 'v4');
// if(!isV4){
//   axiosInstance.defaults.headers.common['x-api-version'] = API_VERSION;
// }

axiosInstance.defaults.headers.common['Accept-Language'] = '';
axiosInstance.defaults.headers.common.Authorization = `${accessToken}`; //`Bearer ${accessToken}`;

axiosInstance.interceptors.request.use(
  (config) => {
    const currentAddressBarUrl = window.location.href;
    
    if (currentAddressBarUrl.includes('/v5/')) {
      config.headers['x-api-version'] = API_VERSION;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    try {
      if(error.response.status == 401){
        setSession(null, null, null, false);
        window.location.href = '/';
      }
    } catch(err) {}

    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};
